export const getCityList = () => fetch("/city_list.json").then((data) => data.json());